import React from 'react';

import { FeatureFlagOverridesContext } from './feature-flag-overrides-context';
import type { FlagOverrides } from './types';

type FeatureFlagOverrideProps = {
	flagOverrides: FlagOverrides;
	children: React.ReactNode;
};

/**
 * __Feature flag override__
 *
 * Allows overriding feature flags, limited to a subtree of the application.
 */
export const FeatureFlagOverrides: ({
	flagOverrides,
	children,
}: FeatureFlagOverrideProps) => React.JSX.Element = ({
	flagOverrides,
	children,
}: FeatureFlagOverrideProps): React.JSX.Element => {
	return (
		<FeatureFlagOverridesContext.Provider
			value={{
				flagOverrides,
			}}
		>
			{/* Key on Fragment forces complete remount of children when path changes,
			    ensuring components that use fg() directly re-evaluate their flags */}
			{children}
		</FeatureFlagOverridesContext.Provider>
	);
};
